<template>  
  <div class="lead-generation">
    <div class="lead-generation__body">
      <h1  v-if="showTitle" v-html="body.title" :style="titleStyle"></h1>
      <div  class="klavio_form" v-if="body.content" v-html="body.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  component: 'LeadGenerationBody',
  props: {

    body: {
      type: Object,
      default: () => ({}),
      required: false
    }
  },
  computed: {
    showTitle (){
      return this.body.showTitle;
    },
    titleStyle () {
      return  `font-size: ${this.body.fontSizeDesktop}!important`
    }
  }
}
</script>

<style lang="scss" scoped>
.klavio_form {
  width: 64%;
  margin: 0 auto;
  margin-bottom: 100px;
  @include mobile-only {
    width: 100%;
  }
}
.lead-generation {
  &__body{

    h1 {
      margin: auto;
      font-size: 52px;
      letter-spacing: 0;
      line-height: 1;
      font-family: "Ginkgo-Light";
      font-weight: 400;
      text-transform: none;
      margin-top:20px ;
      padding-bottom: 10px;
      text-align: center;

      @include mobile-only {
        font-size: 28px;
      }
    }
  }
}
</style>
